import { Stack, Typography } from "@mui/material";

const MAX_TOOLTIP_VALUES = 10;

interface Props {
  values: string[];
}

const ConditionValuesTooltip = ({ values }: Props) => {
  const visibleValues = values.slice(0, MAX_TOOLTIP_VALUES);
  const hiddenCount = values.length - visibleValues.length;

  return (
    <Stack>
      {visibleValues.map((value) => (
        <Typography key={value} variant="caption">
          {value}
        </Typography>
      ))}
      {hiddenCount > 0 && <Typography variant="caption">{`+${hiddenCount} more`}</Typography>}
    </Stack>
  );
};

export default ConditionValuesTooltip;
